import segmentPlugin from '@analytics/segment';
import { Analytics as analytics } from 'analytics';

import jira from 'src/lib/api/jira';
import { getEnvironment } from 'src/lib/featureFlags';

let instance = null;
const EVENT_PREFIX = 'jiraserver_';

export const initializeAnalytics = () => {
  if (window.Cypress) return;
  const { segmentKey } = getEnvironment();
  instance = analytics({
    app: 'integration-jira-ui',
    plugins: [
      segmentPlugin({
        writeKey: segmentKey
      })
    ]
  });
};

export const getCurrentUserId = () => {
  if (!instance) return null;
  return instance.user().userId;
};

export const identifyFromUser = (user) => {
  if (!instance || !user) return;
  instance.identify(
    user.id,
    {
      name: user.name,
      email: user.email,
      role: user.role
    }
  );
};

export const trackEvent = (eventName, props, callback) => {
  if (!instance) return;
  const jiraMetadata = jira.getMetadata();
  instance.track(`${EVENT_PREFIX}${eventName}`, {
    jiraVersion: jiraMetadata?.version,
    jiraType: jiraMetadata?.type,
    pluginVersion: jiraMetadata?.pluginVersion,
    ...props,
  }, callback);
};
